/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ArticleProcessingRequest } from '../models';
// @ts-ignore
import type { ArticleProcessingResponse } from '../models';
// @ts-ignore
import type { UserCallbackUrlRequest } from '../models';
// @ts-ignore
import type { UserCallbackUrlResponse } from '../models';
/**
 * UserCallbackURLApi - axios parameter creator
 * @export
 */
export const UserCallbackURLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-callback-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrent: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-callback-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, retrieves market cap data, and sends the result to the user\'s configured callback URL
         * @summary Process article and send to callback URL
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processArticleAndCallback: async (articleProcessingRequest: ArticleProcessingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleProcessingRequest' is not null or undefined
            assertParamExists('processArticleAndCallback', 'articleProcessingRequest', articleProcessingRequest)
            const localVarPath = `/api/user-callback-url/process-article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(articleProcessingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, and retrieves market cap data
         * @summary Process article for testing
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestArticle: async (articleProcessingRequest: ArticleProcessingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleProcessingRequest' is not null or undefined
            assertParamExists('sendTestArticle', 'articleProcessingRequest', articleProcessingRequest)
            const localVarPath = `/api/user-callback-url/test-article`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(articleProcessingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates the URL and headers for the current user
         * @summary Upsert current user\'s callback configuration
         * @param {UserCallbackUrlRequest} userCallbackUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert: async (userCallbackUrlRequest: UserCallbackUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCallbackUrlRequest' is not null or undefined
            assertParamExists('upsert', 'userCallbackUrlRequest', userCallbackUrlRequest)
            const localVarPath = `/api/user-callback-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCallbackUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserCallbackURLApi - functional programming interface
 * @export
 */
export const UserCallbackURLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserCallbackURLApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCallbackURLApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrent(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCallbackUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrent(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCallbackURLApi.getCurrent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, retrieves market cap data, and sends the result to the user\'s configured callback URL
         * @summary Process article and send to callback URL
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processArticleAndCallback(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processArticleAndCallback(articleProcessingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCallbackURLApi.processArticleAndCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, and retrieves market cap data
         * @summary Process article for testing
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestArticle(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleProcessingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestArticle(articleProcessingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCallbackURLApi.sendTestArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or updates the URL and headers for the current user
         * @summary Upsert current user\'s callback configuration
         * @param {UserCallbackUrlRequest} userCallbackUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsert(userCallbackUrlRequest: UserCallbackUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCallbackUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsert(userCallbackUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCallbackURLApi.upsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserCallbackURLApi - factory interface
 * @export
 */
export const UserCallbackURLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserCallbackURLApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user\'s callback configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrent(options?: RawAxiosRequestConfig): AxiosPromise<UserCallbackUrlResponse> {
            return localVarFp.getCurrent(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, retrieves market cap data, and sends the result to the user\'s configured callback URL
         * @summary Process article and send to callback URL
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processArticleAndCallback(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.processArticleAndCallback(articleProcessingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches an article using the specified credential, detects buy/sell tickers, and retrieves market cap data
         * @summary Process article for testing
         * @param {ArticleProcessingRequest} articleProcessingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestArticle(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleProcessingResponse> {
            return localVarFp.sendTestArticle(articleProcessingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates the URL and headers for the current user
         * @summary Upsert current user\'s callback configuration
         * @param {UserCallbackUrlRequest} userCallbackUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsert(userCallbackUrlRequest: UserCallbackUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserCallbackUrlResponse> {
            return localVarFp.upsert(userCallbackUrlRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserCallbackURLApi - object-oriented interface
 * @export
 * @class UserCallbackURLApi
 * @extends {BaseAPI}
 */
export class UserCallbackURLApi extends BaseAPI {
    /**
     * 
     * @summary Delete current user\'s callback configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCallbackURLApi
     */
    public _delete(options?: RawAxiosRequestConfig) {
        return UserCallbackURLApiFp(this.configuration)._delete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user\'s callback configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCallbackURLApi
     */
    public getCurrent(options?: RawAxiosRequestConfig) {
        return UserCallbackURLApiFp(this.configuration).getCurrent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches an article using the specified credential, detects buy/sell tickers, retrieves market cap data, and sends the result to the user\'s configured callback URL
     * @summary Process article and send to callback URL
     * @param {ArticleProcessingRequest} articleProcessingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCallbackURLApi
     */
    public processArticleAndCallback(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig) {
        return UserCallbackURLApiFp(this.configuration).processArticleAndCallback(articleProcessingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches an article using the specified credential, detects buy/sell tickers, and retrieves market cap data
     * @summary Process article for testing
     * @param {ArticleProcessingRequest} articleProcessingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCallbackURLApi
     */
    public sendTestArticle(articleProcessingRequest: ArticleProcessingRequest, options?: RawAxiosRequestConfig) {
        return UserCallbackURLApiFp(this.configuration).sendTestArticle(articleProcessingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates the URL and headers for the current user
     * @summary Upsert current user\'s callback configuration
     * @param {UserCallbackUrlRequest} userCallbackUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCallbackURLApi
     */
    public upsert(userCallbackUrlRequest: UserCallbackUrlRequest, options?: RawAxiosRequestConfig) {
        return UserCallbackURLApiFp(this.configuration).upsert(userCallbackUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

